import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
export const ToastLink = (param)=>{
    let { className, ...props } = param;
    return /*#__PURE__*/ _jsx("button", {
        className: tailwindMerge("line-height-[1.5] inline-block max-w-[200px] truncate text-16 font-medium text-blue-6 hover:text-blue-7 md:max-w-[328px]", className),
        ...props
    });
};
